import React, { useMemo, useContext, useState, useEffect } from "react";
import { useFilterOptions } from "@/services/right-sizing/filter.repo";
import styles from "@/page-components/RightSizing/rightSizing.module.css";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import { Button } from "react-bootstrap";
import TagItem from "./tag-item.part";
import add from "@/assets/img/add.svg";
import { useNavigate } from "react-router-dom";
import { CostRecommendationContext } from "../../costContext";
import { useCostRecommendationFilterOptions } from "@/services/cost-recommendation/getFilter.repo";

const FilterSection = ({ service, name }) => {
  const context = useContext(CostRecommendationContext);
  const [isAddButtonDisabled, setIsAddButtonDisabled] = useState(true);
  const selectedAccountIds = (context.selectedAccounts || []).map((e) => e.id);
  const [Type, setType] = useState("account");

  const res = useMemo(() => {
    return {
      service,
      type: Type,
    };
  }, [Type, service]);
  const { data: dropdown, isLoading } = useCostRecommendationFilterOptions(res);

  useEffect(() => {
    const disableAddButton = context.selectedTags.some(
      (tag) => tag.filterOn === "" || tag.values.length === 0
    );
    setIsAddButtonDisabled(disableAddButton);
  }, [context.selectedTags]);

  return (
    <>
      <div className={styles.filter_main_div} style={{ minWidth: 0 }}>
        <Filter
          isLoading={isLoading}
          setType={setType}
          tittle={name}
          data={dropdown?.data}
          filterType="account"
          selectedValues={context.selectedAccounts}
          onSelect={(list) => {
            context?.setSelectedAccounts(list);
          }}
          onRemove={(list) => {
            context?.setSelectedAccounts(list);
          }}
        />
        {/* 
        {service === "azure" && context?.selectedAccounts?.length > 0 && (
          <Filter
            isLoading={isLoading}
            setType={setType}
            tittle={"Resource Group"}
            data={dropdown?.data?.resourceGroupName}
            filterType="resourcegroupname"
            selectedValues={context.selectedResourceGroup}
            onSelect={(list) => {
              context?.setSelectedResourceGroup(list);
            }}
            onRemove={(list) => {
              context?.setSelectedResourceGroup(list);
            }}
          />
        )} */}

        <Filter
          isLoading={isLoading}
          setType={setType}
          tittle={"Region"}
          data={dropdown?.data}
          filterType="region"
          selectedValues={context.selectedRegions}
          onSelect={(list) => {
            context?.setSelectedRegions(list);
          }}
          onRemove={(list) => {
            context?.setSelectedRegions(list);
          }}
        />

        <Filter
          isLoading={isLoading}
          setType={setType}
          tittle={"Resource Type"}
          data={dropdown?.data}
          filterType="resource_type"
          selectedValues={context.selectedResourceType}
          onSelect={(list) => {
            context?.setSelectedResourceType(list);
          }}
          onRemove={(list) => {
            context?.setSelectedResourceType(list);
          }}
        />
        {service === "azure" && (
          <>
            <Filter
              isLoading={isLoading}
              setType={setType}
              tittle={"Impact"}
              data={dropdown?.data}
              filterType="impact"
              selectedValues={context.selectedImpact}
              onSelect={(list) => {
                context?.setSelectedImpact(list);
              }}
              onRemove={(list) => {
                context?.setSelectedImpact(list);
              }}
            />
          </>
        )}

        {/* <hr className="w-100 mb-0" />

        <div className={styles.filter_box_div}>
          <div className={styles.filter_name_addsign}>
            <div className={styles.filter_name}>Tags</div>
            <Button
              variant="link"
              className="p-0"
              onClick={() => {
                context.setSelectedTags((arr) => {
                  const newArr = [...arr];
                  newArr.push({
                    filterOn: "",
                    filterType: "include",
                    values: [],
                  });
                  return newArr;
                });
              }}
              disabled={isAddButtonDisabled}
              style={{
                opacity: isAddButtonDisabled ? 0.4 : "",
                fill: isAddButtonDisabled ? "#CED4DA" : "",
                pointerEvents: isAddButtonDisabled ? "none" : "auto",
              }}
            >
              <img src={add} alt="" />
            </Button>
          </div>
          {context.selectedTags.map((tag, index) => (
            <TagItem service={service} tag={tag} index={index} />
          ))}
        </div> */}
      </div>
    </>
  );
};

const Filter = ({
  isLoading,
  setType,
  tittle,
  data,
  setSelectedValues,

  filterType,
  selectedValues,
  onSelect,
  onRemove,
}) => {
  const context = useContext(CostRecommendationContext);

  const handleSelect = (selectedList) => {
    if (filterType === "account") {
      context.setSelectedAccounts(selectedList);
    }
    if (filterType === "resourcegroupname") {
      context.setSelectedResourceGroup(selectedList);
    }
    if (filterType === "region") {
      context.setSelectedRegions(selectedList);
    }
    if (filterType === "resource_type") {
      context.setSelectedResourceType(selectedList);
    }
    if (filterType === "impact") {
      context.setSelectedImpact(selectedList);
    }
  };

  const handleRemove = (selectedList) => {
    handleSelect(selectedList);
  };

  const handleTittle = (title) => {
    if (title === "Subscription Name" || title === "Account Name") {
      title = "Account";
    }
    if (title === "Resource Type") {
      title = "resource_type";
    }
    setType(title?.toLowerCase());
  };

  const navigate = useNavigate();
  const handleTagSelection = () => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set("page", "1");
    navigate(`?${searchParams.toString()}`);
  };

  return (
    <>
      <div className={styles.filter_padding_div}>
        <div className={styles.dimension_div}>
          <div className={styles.dimension_name_css}>{tittle}</div>
          <div
            onClick={() => handleTittle(tittle)}
            className={styles.filter_group_name_css}
          >
            <FilterSearch
              loading={isLoading}
              multiselect={true}
              options={(data || []).map((e) => {
                return {
                  id: e.id,
                  name: e.name,
                };
              })}
              selectedValues={selectedValues || []}
              onSelect={(list) => {
                handleTagSelection();
                handleRemove(list);
              }}
              onRemove={(list) => {
                handleRemove(list);
              }}
              displayValue="name"
              placeholder="--Select--"
              toggle={
                <>
                  <FilterSearchToggle placeholder={tittle} />
                </>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FilterSection;
